<template>
  <a-card>
    <draggable
      v-model="myArray"
      chosen-class="chosen"
      force-fallback="true"
      group="people"
      animation="1000"
      @start="onStart"
      @end="onEnd"
    >
      <div class="item" v-for="element in myArray" :key="element.id">
        <gridLayout></gridLayout>
      </div>
    </draggable>
  </a-card>
</template>
<script>
import gridLayout from './GridLayout.vue';
import draggable from 'vuedraggable';
export default {
  data() {
    return {
      myArray: [
        { people: 'cn', id: 1, name: 'www.itxst.com' },
        { people: 'cn', id: 2, name: 'www.baidu.com' },
        { people: 'cn', id: 3, name: 'www.taobao.com' },
        { people: 'us', id: 4, name: 'www.google.com' },
      ],
    };
  },
  components: {
    draggable,
    gridLayout,
  },
  methods: {
    onStart() {
      this.drag = true;
    },
    onEnd() {
      this.drag = false;

      console.log(this.myArray);
    },
  },
};
</script>
